import { Type } from "@angular/core";
import { TextCellComponent } from "../../components/text-cell/text-cell.component";
import { Col, FilteredKeys } from "./col";

export class TextCol<T extends object> extends Col<T, Type<TextCellComponent<T>>> {
  constructor(
    columnDef: FilteredKeys<T, TextCellComponent<T>["data"]>,
    searchable?: boolean,
    header?: string,
    public datePipeFormat?: string,
    public isTranslate = false,
    removable?: boolean,
    private fatherKey?: string,
    sortable?: boolean
  ) {
    super(TextCellComponent, columnDef, header || columnDef, undefined, searchable, removable, sortable);
  }


  override getElementData(el: T): TextCellComponent<T>["data"] {
    if (this.fatherKey)
      return this.fatherKey + '.' + el[this.columnDef]
    else {
      return el[this.columnDef] as string;
    }

  }
}
